import { api } from "@/lib/api/api";
import { out } from "@/lib/output/out";
import { sleep } from "@/lib/sleep/sleep";
import { interruptibleSleep } from "@/lib/sleep/interruptible-sleep";
import type { FollowSessionDependencies } from "./follow-session-dependencies";

export const defaultFollowSessionDependencies: FollowSessionDependencies = {
  request: api,
  pollSleep: sleep,
  retrySleep: interruptibleSleep,
  random: Math.random,
  // Monotonic: an NTP step backwards must not hand the outage budget more time
  // to burn, nor mute the periodic reminder until the clock catches up.
  now: () => performance.now(),
  warn: (message) => out.warn(message),
};
